/**
 * @generated SignedSource<<8150100262d62ec52f4cad6d068d7b3f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CBPayAssetFilters = {
  networks?: ReadonlyArray<string> | null;
  tickers?: ReadonlyArray<string> | null;
};
export type BuyOneClickPageDataProviderQuery$variables = {
  assetUuid: string;
  buys: boolean;
  fiatCurrency: string;
  filter: CBPayAssetFilters;
  inWebView: boolean;
  sends: boolean;
  skipAccountByUuid: boolean;
  skipAssetByUuid: boolean;
  transactionUuid?: string | null;
  uuid: string;
};
export type BuyOneClickPageDataProviderQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"PolicyRestrictionsGuardFragment" | "useDefaultSourceOfFundsViewerFragment" | "useRunChecksAgainstAssetListFragment" | "useSelectAssetFragment" | "useSourceOfFundsToCommonFormatRequiredData">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"useExchangeRateFragment">;
};
export type BuyOneClickPageDataProviderQuery = {
  response: BuyOneClickPageDataProviderQuery$data;
  variables: BuyOneClickPageDataProviderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "assetUuid"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "buys"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fiatCurrency"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "inWebView"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sends"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipAccountByUuid"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipAssetByUuid"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "transactionUuid"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "uuid"
},
v10 = [
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filter"
  }
],
v11 = {
  "kind": "Variable",
  "name": "transactionUuid",
  "variableName": "transactionUuid"
},
v12 = [
  {
    "kind": "Literal",
    "name": "supportedSourcesOfFunds",
    "value": [
      "PAYMENT_METHOD",
      "FIAT_WALLET",
      "CRYPTO_ACCOUNT"
    ]
  },
  (v11/*: any*/)
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isEnabled",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "TradeAllowance",
  "kind": "LinkedField",
  "name": "tradeCapabilities",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "allowBuy",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "verified",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uuid",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "primaryBuy",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v21 = [
  (v20/*: any*/)
],
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "expiresAt",
  "storageKey": null
},
v23 = {
  "kind": "InlineFragment",
  "selections": [
    (v22/*: any*/)
  ],
  "type": "WorldpayCardPickerData",
  "abstractKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "instantBuy",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "use3ds",
  "storageKey": null
},
v26 = {
  "kind": "InlineDataFragmentSpread",
  "name": "getIsCountryAllowedFiatFragment",
  "selections": [
    (v18/*: any*/),
    (v24/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "pickerData",
      "plural": false,
      "selections": [
        (v13/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v25/*: any*/)
          ],
          "type": "WorldpayCardPickerData",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "args": null,
  "argumentDefinitions": ([]/*: any*/)
},
v27 = [
  (v17/*: any*/)
],
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "Amount",
  "kind": "LinkedField",
  "name": "availableBalance",
  "plural": false,
  "selections": [
    (v28/*: any*/)
  ],
  "storageKey": null
},
v30 = [
  (v28/*: any*/),
  (v20/*: any*/)
],
v31 = {
  "alias": null,
  "args": null,
  "concreteType": "Amount",
  "kind": "LinkedField",
  "name": "availableToSendBalance",
  "plural": false,
  "selections": (v30/*: any*/),
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "AssetBalanceBreakdown",
  "kind": "LinkedField",
  "name": "assetBalanceBreakdown",
  "plural": false,
  "selections": [
    (v31/*: any*/)
  ],
  "storageKey": null
},
v33 = {
  "kind": "InlineFragment",
  "selections": [
    (v32/*: any*/)
  ],
  "type": "ViewerAsset",
  "abstractKey": null
},
v34 = {
  "kind": "InlineDataFragmentSpread",
  "name": "readAccountBalanceFragment",
  "selections": [
    (v29/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "assetOrFiatCurrency",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v18/*: any*/),
            (v32/*: any*/)
          ],
          "type": "TiersCurrency",
          "abstractKey": null
        },
        (v33/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "args": null,
  "argumentDefinitions": ([]/*: any*/)
},
v35 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Asset",
      "kind": "LinkedField",
      "name": "asset",
      "plural": false,
      "selections": (v27/*: any*/),
      "storageKey": null
    }
  ],
  "type": "ViewerAsset",
  "abstractKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "assetOrFiatCurrency",
  "plural": false,
  "selections": [
    (v35/*: any*/)
  ],
  "storageKey": null
},
v37 = {
  "kind": "InlineDataFragmentSpread",
  "name": "getIsCountryAllowedAccountFragment",
  "selections": [
    (v18/*: any*/)
  ],
  "args": null,
  "argumentDefinitions": ([]/*: any*/)
},
v38 = {
  "alias": null,
  "args": null,
  "concreteType": "Amount",
  "kind": "LinkedField",
  "name": "availableToSendBalanceFiat",
  "plural": false,
  "selections": (v30/*: any*/),
  "storageKey": null
},
v39 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AssetBalanceBreakdown",
    "kind": "LinkedField",
    "name": "assetBalanceBreakdown",
    "plural": false,
    "selections": [
      (v38/*: any*/)
    ],
    "storageKey": null
  }
],
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "symbol",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageUrl",
  "storageKey": null
},
v43 = {
  "kind": "InlineDataFragmentSpread",
  "name": "readCryptoAccountFragment",
  "selections": [
    (v37/*: any*/),
    (v34/*: any*/),
    {
      "kind": "InlineDataFragmentSpread",
      "name": "readAccountBalanceFiatFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "assetOrFiatCurrency",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": (v39/*: any*/),
              "type": "TiersCurrency",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v39/*: any*/),
              "type": "ViewerAsset",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": ([]/*: any*/)
    },
    (v17/*: any*/),
    (v40/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "assetOrFiatCurrency",
      "plural": false,
      "selections": [
        (v13/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Asset",
              "kind": "LinkedField",
              "name": "asset",
              "plural": false,
              "selections": [
                (v17/*: any*/),
                (v41/*: any*/),
                (v40/*: any*/),
                (v42/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "type": "ViewerAsset",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v40/*: any*/)
          ],
          "type": "TiersCurrency",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "args": null,
  "argumentDefinitions": ([]/*: any*/)
},
v44 = [
  (v43/*: any*/)
],
v45 = {
  "alias": null,
  "args": null,
  "concreteType": "Amount",
  "kind": "LinkedField",
  "name": "remainingAvailableLimit",
  "plural": false,
  "selections": [
    (v20/*: any*/),
    (v28/*: any*/)
  ],
  "storageKey": null
},
v46 = {
  "alias": "paymentMethodName",
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v47 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountNumber",
      "storageKey": null
    }
  ],
  "type": "BankPickerDataV2",
  "abstractKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "institutionName",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bin",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cardLast4",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "requires3dsDdc",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "concreteType": "Amount",
  "kind": "LinkedField",
  "name": "remainingAvailableLimit",
  "plural": false,
  "selections": (v30/*: any*/),
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v55 = {
  "kind": "InlineDataFragmentSpread",
  "name": "readFiatWalletAccountFragment",
  "selections": [
    (v37/*: any*/),
    (v34/*: any*/),
    (v17/*: any*/),
    (v40/*: any*/),
    (v18/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "assetOrFiatCurrency",
      "plural": false,
      "selections": [
        (v13/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v54/*: any*/),
            (v40/*: any*/),
            (v18/*: any*/)
          ],
          "type": "TiersCurrency",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "args": null,
  "argumentDefinitions": ([]/*: any*/)
},
v56 = {
  "alias": null,
  "args": null,
  "concreteType": "PaymentLimits",
  "kind": "LinkedField",
  "name": "limits",
  "plural": false,
  "selections": [
    (v52/*: any*/)
  ],
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "concreteType": "Amount",
  "kind": "LinkedField",
  "name": "availableBalanceInNativeCurrency",
  "plural": false,
  "selections": (v21/*: any*/),
  "storageKey": null
},
v58 = {
  "kind": "Variable",
  "name": "uuid",
  "variableName": "uuid"
},
v59 = [
  (v58/*: any*/)
],
v60 = [
  {
    "kind": "Variable",
    "name": "quoteCurrency",
    "variableName": "fiatCurrency"
  }
],
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "price",
  "storageKey": null
},
v62 = {
  "kind": "Variable",
  "name": "fiatCurrency",
  "variableName": "fiatCurrency"
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v64 = [
  (v63/*: any*/)
],
v65 = {
  "kind": "InlineFragment",
  "selections": (v64/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v66 = {
  "kind": "InlineFragment",
  "selections": (v64/*: any*/),
  "type": "ViewerEquity",
  "abstractKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "concreteType": "AssetBalanceBreakdown",
  "kind": "LinkedField",
  "name": "assetBalanceBreakdown",
  "plural": false,
  "selections": [
    (v31/*: any*/),
    (v38/*: any*/)
  ],
  "storageKey": null
},
v68 = {
  "kind": "InlineFragment",
  "selections": [
    (v18/*: any*/),
    (v67/*: any*/),
    (v63/*: any*/),
    (v40/*: any*/)
  ],
  "type": "TiersCurrency",
  "abstractKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "concreteType": "Asset",
  "kind": "LinkedField",
  "name": "asset",
  "plural": false,
  "selections": [
    (v17/*: any*/),
    (v63/*: any*/),
    (v41/*: any*/),
    (v40/*: any*/),
    (v42/*: any*/)
  ],
  "storageKey": null
},
v70 = [
  {
    "alias": null,
    "args": (v60/*: any*/),
    "concreteType": "LatestAssetPrice",
    "kind": "LinkedField",
    "name": "latestPrice",
    "plural": false,
    "selections": [
      (v61/*: any*/),
      (v63/*: any*/)
    ],
    "storageKey": null
  },
  (v63/*: any*/)
],
v71 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "restrictionName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Link",
    "kind": "LinkedField",
    "name": "link",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "text",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  (v53/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  },
  (v63/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "BuyOneClickPageDataProviderQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": null,
          "concreteType": "Viewer",
          "kind": "LinkedField",
          "name": "viewer",
          "plural": false,
          "selections": [
            {
              "args": (v10/*: any*/),
              "kind": "FragmentSpread",
              "name": "useSelectAssetFragment"
            },
            {
              "args": (v10/*: any*/),
              "kind": "FragmentSpread",
              "name": "useRunChecksAgainstAssetListFragment"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "useSourceOfFundsToCommonFormatRequiredData"
            },
            {
              "kind": "InlineDataFragmentSpread",
              "name": "useDefaultSourceOfFundsViewerFragment",
              "selections": [
                {
                  "alias": null,
                  "args": (v12/*: any*/),
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "cbPaySourcesOfFunds",
                  "plural": true,
                  "selections": [
                    (v13/*: any*/),
                    {
                      "kind": "InlineDataFragmentSpread",
                      "name": "readPrimaryPaymentMethodSoFFragment",
                      "selections": [
                        (v13/*: any*/),
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v14/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "PaymentMethodV2",
                              "kind": "LinkedField",
                              "name": "paymentMethod",
                              "plural": false,
                              "selections": [
                                (v15/*: any*/),
                                (v16/*: any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": null,
                                  "kind": "LinkedField",
                                  "name": "pickerData",
                                  "plural": false,
                                  "selections": [
                                    (v13/*: any*/)
                                  ],
                                  "storageKey": null
                                },
                                {
                                  "kind": "InlineDataFragmentSpread",
                                  "name": "readPrimaryPaymentMethodFragment",
                                  "selections": [
                                    (v17/*: any*/),
                                    (v18/*: any*/),
                                    (v19/*: any*/),
                                    {
                                      "alias": null,
                                      "args": null,
                                      "concreteType": "PaymentLimits",
                                      "kind": "LinkedField",
                                      "name": "limits",
                                      "plural": false,
                                      "selections": [
                                        {
                                          "alias": null,
                                          "args": null,
                                          "concreteType": "Amount",
                                          "kind": "LinkedField",
                                          "name": "remainingAvailableLimit",
                                          "plural": false,
                                          "selections": (v21/*: any*/),
                                          "storageKey": null
                                        }
                                      ],
                                      "storageKey": null
                                    },
                                    {
                                      "alias": null,
                                      "args": null,
                                      "concreteType": null,
                                      "kind": "LinkedField",
                                      "name": "pickerData",
                                      "plural": false,
                                      "selections": [
                                        (v13/*: any*/),
                                        (v23/*: any*/)
                                      ],
                                      "storageKey": null
                                    }
                                  ],
                                  "args": null,
                                  "argumentDefinitions": []
                                },
                                (v26/*: any*/)
                              ],
                              "storageKey": null
                            }
                          ],
                          "type": "CBPaySourceOfFundsPaymentMethod",
                          "abstractKey": null
                        }
                      ],
                      "args": null,
                      "argumentDefinitions": []
                    },
                    {
                      "kind": "InlineDataFragmentSpread",
                      "name": "readPrimaryFiatWalletFragment",
                      "selections": [
                        (v13/*: any*/),
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v14/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "PaymentMethodV2",
                              "kind": "LinkedField",
                              "name": "paymentMethod",
                              "plural": false,
                              "selections": (v27/*: any*/),
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Account",
                              "kind": "LinkedField",
                              "name": "account",
                              "plural": false,
                              "selections": [
                                (v34/*: any*/)
                              ],
                              "storageKey": null
                            }
                          ],
                          "type": "CBPaySourceOfFundsFiatWallet",
                          "abstractKey": null
                        }
                      ],
                      "args": null,
                      "argumentDefinitions": []
                    },
                    {
                      "kind": "InlineDataFragmentSpread",
                      "name": "readPrimaryCryptoAccountFragment",
                      "selections": [
                        (v13/*: any*/),
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Account",
                              "kind": "LinkedField",
                              "name": "account",
                              "plural": false,
                              "selections": [
                                (v34/*: any*/),
                                (v36/*: any*/)
                              ],
                              "storageKey": null
                            }
                          ],
                          "type": "CBPaySourceOfFundsCryptoAccount",
                          "abstractKey": null
                        }
                      ],
                      "args": null,
                      "argumentDefinitions": []
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Account",
                          "kind": "LinkedField",
                          "name": "account",
                          "plural": false,
                          "selections": (v44/*: any*/),
                          "storageKey": null
                        },
                        (v45/*: any*/)
                      ],
                      "type": "CBPaySourceOfFundsCryptoAccount",
                      "abstractKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v14/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "PaymentMethodV2",
                          "kind": "LinkedField",
                          "name": "paymentMethod",
                          "plural": false,
                          "selections": [
                            (v17/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": null,
                              "kind": "LinkedField",
                              "name": "pickerData",
                              "plural": false,
                              "selections": [
                                (v23/*: any*/)
                              ],
                              "storageKey": null
                            },
                            {
                              "kind": "InlineDataFragmentSpread",
                              "name": "readPaymentMethodFragment",
                              "selections": [
                                (v17/*: any*/),
                                (v18/*: any*/),
                                (v46/*: any*/),
                                (v28/*: any*/),
                                (v16/*: any*/),
                                (v15/*: any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": null,
                                  "kind": "LinkedField",
                                  "name": "pickerData",
                                  "plural": false,
                                  "selections": [
                                    (v13/*: any*/),
                                    (v47/*: any*/),
                                    {
                                      "kind": "InlineFragment",
                                      "selections": [
                                        (v48/*: any*/),
                                        (v49/*: any*/),
                                        (v50/*: any*/),
                                        (v25/*: any*/),
                                        (v51/*: any*/),
                                        (v22/*: any*/)
                                      ],
                                      "type": "WorldpayCardPickerData",
                                      "abstractKey": null
                                    }
                                  ],
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "PaymentLimits",
                                  "kind": "LinkedField",
                                  "name": "limits",
                                  "plural": false,
                                  "selections": [
                                    (v52/*: any*/),
                                    (v53/*: any*/)
                                  ],
                                  "storageKey": null
                                },
                                (v26/*: any*/)
                              ],
                              "args": null,
                              "argumentDefinitions": []
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "type": "CBPaySourceOfFundsPaymentMethod",
                      "abstractKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Account",
                          "kind": "LinkedField",
                          "name": "account",
                          "plural": false,
                          "selections": [
                            (v55/*: any*/)
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "PaymentMethodV2",
                          "kind": "LinkedField",
                          "name": "paymentMethod",
                          "plural": false,
                          "selections": [
                            (v17/*: any*/),
                            {
                              "kind": "InlineDataFragmentSpread",
                              "name": "readFiatWalletPaymentMethodFragment",
                              "selections": [
                                (v17/*: any*/),
                                (v40/*: any*/),
                                (v18/*: any*/),
                                (v28/*: any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": null,
                                  "kind": "LinkedField",
                                  "name": "pickerData",
                                  "plural": false,
                                  "selections": [
                                    (v13/*: any*/),
                                    {
                                      "kind": "InlineFragment",
                                      "selections": [
                                        {
                                          "alias": null,
                                          "args": null,
                                          "concreteType": "PaymentMethodFiatAccount",
                                          "kind": "LinkedField",
                                          "name": "fiatAccount",
                                          "plural": false,
                                          "selections": (v27/*: any*/),
                                          "storageKey": null
                                        }
                                      ],
                                      "type": "CoinbaseFiatAccountPickerData",
                                      "abstractKey": null
                                    }
                                  ],
                                  "storageKey": null
                                },
                                (v56/*: any*/)
                              ],
                              "args": null,
                              "argumentDefinitions": []
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "type": "CBPaySourceOfFundsFiatWallet",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountConnection",
                  "kind": "LinkedField",
                  "name": "accountsV2",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Account",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v17/*: any*/),
                            (v36/*: any*/),
                            (v43/*: any*/),
                            (v55/*: any*/)
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "kind": "InlineDataFragmentSpread",
                  "name": "readPrimaryCryptoAccountFromAccountsV2",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountConnection",
                      "kind": "LinkedField",
                      "name": "accountsV2",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "AccountEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Account",
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                (v18/*: any*/),
                                (v17/*: any*/),
                                (v57/*: any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": null,
                                  "kind": "LinkedField",
                                  "name": "assetOrFiatCurrency",
                                  "plural": false,
                                  "selections": [
                                    (v13/*: any*/),
                                    (v35/*: any*/)
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "args": null,
                  "argumentDefinitions": []
                },
                {
                  "condition": "skipAccountByUuid",
                  "kind": "Condition",
                  "passingValue": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": (v59/*: any*/),
                      "concreteType": "Account",
                      "kind": "LinkedField",
                      "name": "accountByUuid",
                      "plural": false,
                      "selections": (v44/*: any*/),
                      "storageKey": null
                    }
                  ]
                },
                {
                  "condition": "skipAssetByUuid",
                  "kind": "Condition",
                  "passingValue": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": (v59/*: any*/),
                      "concreteType": "ViewerAsset",
                      "kind": "LinkedField",
                      "name": "assetByUuid",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Asset",
                          "kind": "LinkedField",
                          "name": "asset",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": (v60/*: any*/),
                              "concreteType": "LatestAssetPrice",
                              "kind": "LinkedField",
                              "name": "latestPrice",
                              "plural": false,
                              "selections": [
                                (v61/*: any*/)
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ]
                }
              ],
              "args": [
                (v62/*: any*/),
                {
                  "kind": "Variable",
                  "name": "skipAccountByUuid",
                  "variableName": "skipAccountByUuid"
                },
                {
                  "kind": "Variable",
                  "name": "skipAssetByUuid",
                  "variableName": "skipAssetByUuid"
                },
                (v11/*: any*/),
                (v58/*: any*/)
              ],
              "argumentDefinitions": [
                (v2/*: any*/),
                (v6/*: any*/),
                (v7/*: any*/),
                (v8/*: any*/),
                (v9/*: any*/)
              ]
            },
            {
              "args": [
                {
                  "kind": "Variable",
                  "name": "buys",
                  "variableName": "buys"
                },
                {
                  "kind": "Variable",
                  "name": "inWebView",
                  "variableName": "inWebView"
                },
                {
                  "kind": "Variable",
                  "name": "sends",
                  "variableName": "sends"
                }
              ],
              "kind": "FragmentSpread",
              "name": "PolicyRestrictionsGuardFragment"
            }
          ],
          "storageKey": null
        },
        "action": "THROW",
        "path": "viewer"
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "assetUuid",
            "variableName": "assetUuid"
          },
          (v62/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "useExchangeRateFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v6/*: any*/),
      (v2/*: any*/),
      (v7/*: any*/),
      (v5/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "BuyOneClickPageDataProviderQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v10/*: any*/),
            "concreteType": "CbPayAssetConnection",
            "kind": "LinkedField",
            "name": "cbPayTradableAssets",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CBPayAssetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CBPayAsset",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v41/*: any*/),
                      (v17/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NetworkMetadata",
                        "kind": "LinkedField",
                        "name": "networks",
                        "plural": true,
                        "selections": [
                          (v40/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "displayName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "minSend",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isDefault",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v42/*: any*/),
                      (v40/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "exponent",
                        "storageKey": null
                      },
                      (v63/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserProperties",
            "kind": "LinkedField",
            "name": "userProperties",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Country",
                "kind": "LinkedField",
                "name": "country",
                "plural": false,
                "selections": [
                  (v54/*: any*/),
                  (v40/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "showInstantAchUx",
                "storageKey": null
              },
              (v63/*: any*/),
              (v17/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v12/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "cbPaySourcesOfFunds",
            "plural": true,
            "selections": [
              (v13/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isCBPaySourceOfFunds"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PaymentMethodV2",
                    "kind": "LinkedField",
                    "name": "paymentMethod",
                    "plural": false,
                    "selections": [
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PaymentLimits",
                        "kind": "LinkedField",
                        "name": "limits",
                        "plural": false,
                        "selections": [
                          (v45/*: any*/),
                          (v53/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "pickerData",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v22/*: any*/),
                              (v25/*: any*/),
                              (v48/*: any*/),
                              (v49/*: any*/),
                              (v50/*: any*/),
                              (v51/*: any*/)
                            ],
                            "type": "WorldpayCardPickerData",
                            "abstractKey": null
                          },
                          (v47/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v24/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v63/*: any*/),
                      (v46/*: any*/),
                      (v28/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "CBPaySourceOfFundsPaymentMethod",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PaymentMethodV2",
                    "kind": "LinkedField",
                    "name": "paymentMethod",
                    "plural": false,
                    "selections": [
                      (v17/*: any*/),
                      (v63/*: any*/),
                      (v40/*: any*/),
                      (v18/*: any*/),
                      (v28/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "pickerData",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PaymentMethodFiatAccount",
                                "kind": "LinkedField",
                                "name": "fiatAccount",
                                "plural": false,
                                "selections": [
                                  (v17/*: any*/),
                                  (v63/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "CoinbaseFiatAccountPickerData",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v56/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Account",
                    "kind": "LinkedField",
                    "name": "account",
                    "plural": false,
                    "selections": [
                      (v29/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "assetOrFiatCurrency",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v18/*: any*/),
                              (v32/*: any*/),
                              (v63/*: any*/),
                              (v54/*: any*/),
                              (v40/*: any*/)
                            ],
                            "type": "TiersCurrency",
                            "abstractKey": null
                          },
                          (v33/*: any*/),
                          (v65/*: any*/),
                          (v66/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v63/*: any*/),
                      (v18/*: any*/),
                      (v17/*: any*/),
                      (v40/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "CBPaySourceOfFundsFiatWallet",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Account",
                    "kind": "LinkedField",
                    "name": "account",
                    "plural": false,
                    "selections": [
                      (v29/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "assetOrFiatCurrency",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          (v68/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v67/*: any*/),
                              (v69/*: any*/)
                            ],
                            "type": "ViewerAsset",
                            "abstractKey": null
                          },
                          (v65/*: any*/),
                          (v66/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v63/*: any*/),
                      (v18/*: any*/),
                      (v17/*: any*/),
                      (v40/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v45/*: any*/)
                ],
                "type": "CBPaySourceOfFundsCryptoAccount",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountConnection",
            "kind": "LinkedField",
            "name": "accountsV2",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Account",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v18/*: any*/),
                      (v17/*: any*/),
                      (v57/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "assetOrFiatCurrency",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v69/*: any*/),
                              (v67/*: any*/)
                            ],
                            "type": "ViewerAsset",
                            "abstractKey": null
                          },
                          (v65/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v63/*: any*/),
                              (v18/*: any*/),
                              (v67/*: any*/),
                              (v40/*: any*/),
                              (v54/*: any*/)
                            ],
                            "type": "TiersCurrency",
                            "abstractKey": null
                          },
                          (v66/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v63/*: any*/),
                      (v29/*: any*/),
                      (v40/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v63/*: any*/),
          {
            "condition": "skipAccountByUuid",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "alias": null,
                "args": (v59/*: any*/),
                "concreteType": "Account",
                "kind": "LinkedField",
                "name": "accountByUuid",
                "plural": false,
                "selections": [
                  (v18/*: any*/),
                  (v29/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "assetOrFiatCurrency",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/),
                      (v68/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v67/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Asset",
                            "kind": "LinkedField",
                            "name": "asset",
                            "plural": false,
                            "selections": [
                              (v17/*: any*/),
                              (v41/*: any*/),
                              (v40/*: any*/),
                              (v42/*: any*/),
                              (v63/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "ViewerAsset",
                        "abstractKey": null
                      },
                      (v65/*: any*/),
                      (v66/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v17/*: any*/),
                  (v40/*: any*/),
                  (v63/*: any*/)
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "skipAssetByUuid",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "alias": null,
                "args": (v59/*: any*/),
                "concreteType": "ViewerAsset",
                "kind": "LinkedField",
                "name": "assetByUuid",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Asset",
                    "kind": "LinkedField",
                    "name": "asset",
                    "plural": false,
                    "selections": (v70/*: any*/),
                    "storageKey": null
                  },
                  (v63/*: any*/)
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "inWebView",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isWebview2faEligible",
                "storageKey": null
              }
            ]
          },
          {
            "condition": "sends",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "sendRestrictions",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "action",
                    "value": "sends"
                  }
                ],
                "concreteType": "PolicyRestriction",
                "kind": "LinkedField",
                "name": "policyRestrictions",
                "plural": true,
                "selections": (v71/*: any*/),
                "storageKey": "policyRestrictions(action:\"sends\")"
              }
            ]
          },
          {
            "condition": "buys",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "buyRestrictions",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "action",
                    "value": "buys"
                  }
                ],
                "concreteType": "PolicyRestriction",
                "kind": "LinkedField",
                "name": "policyRestrictions",
                "plural": true,
                "selections": (v71/*: any*/),
                "storageKey": "policyRestrictions(action:\"buys\")"
              }
            ]
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "uuid",
            "variableName": "assetUuid"
          }
        ],
        "concreteType": "Asset",
        "kind": "LinkedField",
        "name": "assetByUuid",
        "plural": false,
        "selections": (v70/*: any*/),
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f5ae27948679796ce6ea17402fc71640",
    "id": null,
    "metadata": {},
    "name": "BuyOneClickPageDataProviderQuery",
    "operationKind": "query",
    "text": "query BuyOneClickPageDataProviderQuery(\n  $filter: CBPayAssetFilters!\n  $transactionUuid: Uuid\n  $uuid: Uuid!\n  $skipAccountByUuid: Boolean!\n  $fiatCurrency: TickerSymbol!\n  $skipAssetByUuid: Boolean!\n  $sends: Boolean!\n  $buys: Boolean!\n  $assetUuid: Uuid!\n  $inWebView: Boolean!\n) {\n  viewer {\n    ...useSelectAssetFragment_Vt7Yj\n    ...useRunChecksAgainstAssetListFragment_Vt7Yj\n    ...useSourceOfFundsToCommonFormatRequiredData\n    ...useDefaultSourceOfFundsViewerFragment_HpAvR\n    ...PolicyRestrictionsGuardFragment_KfpDY\n    id\n  }\n  ...useExchangeRateFragment_Velk\n}\n\nfragment PolicyRestrictionsGuardFragment_KfpDY on Viewer {\n  userProperties {\n    uuid\n    country {\n      code\n      name\n    }\n    id\n  }\n  isWebview2faEligible @include(if: $inWebView)\n  sendRestrictions: policyRestrictions(action: sends) @include(if: $sends) {\n    restrictionName\n    link {\n      url\n      text\n    }\n    description\n    message\n    id\n  }\n  buyRestrictions: policyRestrictions(action: buys) @include(if: $buys) {\n    restrictionName\n    link {\n      url\n      text\n    }\n    description\n    message\n    id\n  }\n}\n\nfragment getIsCountryAllowedAccountFragment on Account {\n  type\n}\n\nfragment getIsCountryAllowedFiatFragment on PaymentMethodV2 {\n  type\n  instantBuy\n  pickerData {\n    __typename\n    ... on WorldpayCardPickerData {\n      use3ds\n    }\n    ... on BankPickerDataV2 {\n      __typename\n    }\n  }\n}\n\nfragment readAccountBalanceFiatFragment on Account {\n  assetOrFiatCurrency {\n    __typename\n    ... on TiersCurrency {\n      assetBalanceBreakdown {\n        availableToSendBalanceFiat {\n          currency\n          value\n        }\n      }\n      id\n    }\n    ... on ViewerAsset {\n      assetBalanceBreakdown {\n        availableToSendBalanceFiat {\n          currency\n          value\n        }\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n    ... on ViewerEquity {\n      id\n    }\n  }\n}\n\nfragment readAccountBalanceFragment on Account {\n  availableBalance {\n    currency\n  }\n  assetOrFiatCurrency {\n    __typename\n    ... on TiersCurrency {\n      type\n      assetBalanceBreakdown {\n        availableToSendBalance {\n          currency\n          value\n        }\n      }\n      id\n    }\n    ... on ViewerAsset {\n      assetBalanceBreakdown {\n        availableToSendBalance {\n          currency\n          value\n        }\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n    ... on ViewerEquity {\n      id\n    }\n  }\n}\n\nfragment readCBPayAssetAsOnrampStateFragment on CBPayAsset {\n  uuid\n  symbol\n  imageUrl\n  name\n  exponent\n  networks {\n    name\n    displayName\n    minSend\n    isDefault\n  }\n}\n\nfragment readCryptoAccountFragment on Account {\n  ...getIsCountryAllowedAccountFragment\n  ...readAccountBalanceFragment\n  ...readAccountBalanceFiatFragment\n  uuid\n  name\n  assetOrFiatCurrency {\n    __typename\n    ... on ViewerAsset {\n      asset {\n        uuid\n        symbol\n        name\n        imageUrl\n        id\n      }\n    }\n    ... on TiersCurrency {\n      name\n      id\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n    ... on ViewerEquity {\n      id\n    }\n  }\n}\n\nfragment readFiatWalletAccountFragment on Account {\n  ...getIsCountryAllowedAccountFragment\n  ...readAccountBalanceFragment\n  uuid\n  name\n  type\n  assetOrFiatCurrency {\n    __typename\n    ... on TiersCurrency {\n      code\n      name\n      type\n      id\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n    ... on ViewerEquity {\n      id\n    }\n  }\n}\n\nfragment readFiatWalletPaymentMethodFragment on PaymentMethodV2 {\n  uuid\n  name\n  type\n  currency\n  pickerData {\n    __typename\n    ... on CoinbaseFiatAccountPickerData {\n      fiatAccount {\n        uuid\n        id\n      }\n    }\n  }\n  limits {\n    remainingAvailableLimit {\n      currency\n      value\n    }\n  }\n}\n\nfragment readPaymentMethodFragment on PaymentMethodV2 {\n  ...getIsCountryAllowedFiatFragment\n  uuid\n  type\n  paymentMethodName: name\n  currency\n  verified\n  tradeCapabilities {\n    allowBuy\n  }\n  pickerData {\n    __typename\n    ... on BankPickerDataV2 {\n      accountName\n      accountNumber\n    }\n    ... on WorldpayCardPickerData {\n      institutionName\n      bin\n      cardLast4\n      use3ds\n      requires3dsDdc\n      expiresAt\n    }\n    ... on CoinbaseFiatAccountPickerData {\n      __typename\n    }\n  }\n  limits {\n    remainingAvailableLimit {\n      currency\n      value\n    }\n    description\n  }\n}\n\nfragment readPrimaryCryptoAccountFragment on CBPaySourceOfFunds {\n  __isCBPaySourceOfFunds: __typename\n  __typename\n  ... on CBPaySourceOfFundsCryptoAccount {\n    account {\n      ...readAccountBalanceFragment\n      assetOrFiatCurrency {\n        __typename\n        ... on ViewerAsset {\n          asset {\n            uuid\n            id\n          }\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n        ... on TiersCurrency {\n          id\n        }\n        ... on ViewerEquity {\n          id\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment readPrimaryCryptoAccountFromAccountsV2 on Viewer {\n  accountsV2 {\n    edges {\n      node {\n        type\n        uuid\n        availableBalanceInNativeCurrency {\n          value\n        }\n        assetOrFiatCurrency {\n          __typename\n          ... on ViewerAsset {\n            asset {\n              uuid\n              id\n            }\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n          ... on TiersCurrency {\n            id\n          }\n          ... on ViewerEquity {\n            id\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment readPrimaryFiatWalletFragment on CBPaySourceOfFunds {\n  __isCBPaySourceOfFunds: __typename\n  __typename\n  ... on CBPaySourceOfFundsFiatWallet {\n    isEnabled\n    paymentMethod {\n      uuid\n      id\n    }\n    account {\n      ...readAccountBalanceFragment\n      id\n    }\n  }\n}\n\nfragment readPrimaryPaymentMethodFragment on PaymentMethodV2 {\n  uuid\n  type\n  primaryBuy\n  limits {\n    remainingAvailableLimit {\n      value\n    }\n  }\n  pickerData {\n    __typename\n    ... on WorldpayCardPickerData {\n      expiresAt\n    }\n  }\n}\n\nfragment readPrimaryPaymentMethodSoFFragment on CBPaySourceOfFunds {\n  __isCBPaySourceOfFunds: __typename\n  __typename\n  ... on CBPaySourceOfFundsPaymentMethod {\n    isEnabled\n    paymentMethod {\n      ...readPrimaryPaymentMethodFragment\n      ...getIsCountryAllowedFiatFragment\n      tradeCapabilities {\n        allowBuy\n      }\n      verified\n      pickerData {\n        __typename\n      }\n      id\n    }\n  }\n}\n\nfragment useDefaultSourceOfFundsViewerFragment_HpAvR on Viewer {\n  cbPaySourcesOfFunds(transactionUuid: $transactionUuid, supportedSourcesOfFunds: [\"PAYMENT_METHOD\", \"FIAT_WALLET\", \"CRYPTO_ACCOUNT\"]) {\n    __typename\n    ...readPrimaryPaymentMethodSoFFragment\n    ...readPrimaryFiatWalletFragment\n    ...readPrimaryCryptoAccountFragment\n    ... on CBPaySourceOfFundsCryptoAccount {\n      account {\n        ...readCryptoAccountFragment\n        id\n      }\n      remainingAvailableLimit {\n        value\n        currency\n      }\n    }\n    ... on CBPaySourceOfFundsPaymentMethod {\n      isEnabled\n      paymentMethod {\n        uuid\n        pickerData {\n          __typename\n          ... on WorldpayCardPickerData {\n            expiresAt\n          }\n        }\n        ...readPaymentMethodFragment\n        id\n      }\n    }\n    ... on CBPaySourceOfFundsFiatWallet {\n      account {\n        ...readFiatWalletAccountFragment\n        id\n      }\n      paymentMethod {\n        uuid\n        ...readFiatWalletPaymentMethodFragment\n        id\n      }\n    }\n  }\n  ...readPrimaryCryptoAccountFromAccountsV2\n  accountsV2 {\n    edges {\n      node {\n        uuid\n        assetOrFiatCurrency {\n          __typename\n          ... on ViewerAsset {\n            asset {\n              uuid\n              id\n            }\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n          ... on TiersCurrency {\n            id\n          }\n          ... on ViewerEquity {\n            id\n          }\n        }\n        ...readCryptoAccountFragment\n        ...readFiatWalletAccountFragment\n        id\n      }\n    }\n  }\n  accountByUuid(uuid: $uuid) @skip(if: $skipAccountByUuid) {\n    ...readCryptoAccountFragment\n    id\n  }\n  assetByUuid(uuid: $uuid) @skip(if: $skipAssetByUuid) {\n    asset {\n      latestPrice(quoteCurrency: $fiatCurrency) {\n        price\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment useExchangeRateFragment_Velk on Query {\n  assetByUuid(uuid: $assetUuid) {\n    latestPrice(quoteCurrency: $fiatCurrency) {\n      price\n      id\n    }\n    id\n  }\n}\n\nfragment useFilterCBPayAssetsByDestinationWalletsFragment on CBPayAsset {\n  uuid\n  symbol\n  networks {\n    name\n  }\n}\n\nfragment useRunChecksAgainstAssetListFragment_Vt7Yj on Viewer {\n  cbPayTradableAssets(filter: $filter) {\n    edges {\n      node {\n        ...useFilterCBPayAssetsByDestinationWalletsFragment\n        ...readCBPayAssetAsOnrampStateFragment\n        id\n      }\n    }\n  }\n}\n\nfragment useSelectAssetFragment_Vt7Yj on Viewer {\n  cbPayTradableAssets(filter: $filter) {\n    edges {\n      node {\n        symbol\n        uuid\n        ...useFilterCBPayAssetsByDestinationWalletsFragment\n        ...readCBPayAssetAsOnrampStateFragment\n        id\n      }\n    }\n  }\n  ...useRunChecksAgainstAssetListFragment_Vt7Yj\n}\n\nfragment useSourceOfFundsToCommonFormatRequiredData on Viewer {\n  userProperties {\n    country {\n      code\n    }\n    showInstantAchUx\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "d64e34e9200a520575cc5d9b59156c26";

export default node;
